export default {
  title: 'Articoli popolari',
  list: {
    empty_list: {
      title: 'Nessun articolo popolare ancora.',
    },
    fields: {
      name: 'Nome',
      orders: 'Ordini',
      sales: 'Vendite',
    },
  },
};
